import { httpClient } from '@/utils/httpClient';
import { API_CONFIG } from '@/config/api';

export interface ResetDemoSeedDataResponse {
  status: 'completed';
  durationMs: number;
  seedFiles: string[];
  finalEntityCount: number;
}

export class AdminToolsService {
  async resetDemoSeedData(): Promise<ResetDemoSeedDataResponse> {
    return httpClient.post(
      API_CONFIG.ENDPOINTS.RESET_DEMO_SEED_DATA,
      {},
    ) as Promise<ResetDemoSeedDataResponse>;
  }
}

export const adminToolsService = new AdminToolsService();
